import { Link } from 'react-router-dom'
import type { Category } from '@/types'

const COLORS: Record<string, string> = {
  galon: 'bg-blue-100 text-blue-600',
}

const DEFAULT = 'bg-gray-100 text-gray-500'

export default function CategoryCard({ category }: { category: Category }) {
  const color = COLORS[category.slug] ?? DEFAULT

  return (
    <Link
      to={`/kategori/${category.slug}`}
      className="flex flex-col items-center gap-2 p-3 rounded-xl hover:bg-gray-50 transition-colors"
    >
      <div className={`w-16 h-16 rounded-2xl flex items-center justify-center border border-black/5 shadow-sm ${color}`}>
        {category.gambar_url ? (
          <img
            src={category.gambar_url}
            alt={category.nama}
            className="w-full h-full object-cover rounded-2xl"
          />
        ) : (
          <span className="text-xl font-bold">{category.nama.charAt(0)}</span>
        )}
      </div>
      <span className="text-xs font-medium text-gray-700 text-center whitespace-nowrap">
        {category.nama}
      </span>
    </Link>
  )
}
